export default "__VITE_ASSET__BVFFYsRG__"